import { ArrowUpRight } from "lucide-react";

export const EnquireButton = ({ testId, label = "Enquire", variant = "solid", className = "" }) => {
  const base =
    "group inline-flex items-center gap-2 rounded-full font-medium transition-all duration-300 px-7 py-3.5 text-sm tracking-wide";
  const styles =
    variant === "solid"
      ? "bg-primary text-bg hover:bg-primaryHover hover:shadow-[0_0_28px_rgba(216,153,83,0.35)]"
      : "border border-line text-textMain hover:border-primary hover:text-primary";

  return (
    <a href="#enquire" data-testid={testId} className={`${base} ${styles} ${className}`}>
      {label}
      <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
    </a>
  );
};
